import { render, staticRenderFns } from "./InviteFriendsPopup.vue?vue&type=template&id=4c95ec5e&"
import script from "./InviteFriendsPopup.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsPopup.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendsPopup.vue?vue&type=style&index=0&id=4c95ec5e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports